module.exports = __webpack_public_path__ + "img/default-logo.b157165a.svg";